/**
 * @generated SignedSource<<4abfef78baeb9cd279edc245b955a0da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPlId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProgramLineDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteResellerProgramLineTPayload",
        "kind": "LinkedField",
        "name": "deleteResellerProgramLineTByResellerPlId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramLineT",
            "kind": "LinkedField",
            "name": "resellerProgramLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerProgramLineDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteResellerProgramLineTPayload",
        "kind": "LinkedField",
        "name": "deleteResellerProgramLineTByResellerPlId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramLineT",
            "kind": "LinkedField",
            "name": "resellerProgramLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9950b717dbc0ddb68da8175d1fcdfc0",
    "id": null,
    "metadata": {},
    "name": "ResellerProgramLineDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ResellerProgramLineDeleteMutation(\n  $input: DeleteResellerProgramLineTByResellerPlIdInput!\n) {\n  deleteResellerProgramLineTByResellerPlId(input: $input) {\n    resellerProgramLineT {\n      resellerPlId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "569e25ef647eea45ddd4384b87617f34";

module.exports = node;
